/* RX-O2: progressive category navigation for Launch 6.8.2, plus hub directory. */
(() => {
  'use strict';
  if (window.RXO2Conditions) { window.RXO2Conditions.refresh(); return; }
  const hubPath = '/pages/hbot-research';
  const states = [];
  const smallScreen = window.matchMedia('(max-width:640px)');
  let source;
  let serial = 0;
  const path = href => { try { return new URL(href, location.href).pathname.replace(/\/$/, ''); } catch (_) { return ''; } };
  const focusables = panel => Array.from(panel.querySelectorAll('a[href],button,summary,input,select')).filter(el => !el.closest('[hidden]') && el.getClientRects().length && !el.disabled);
  const accordion = state => state.mode === 'drawer' || smallScreen.matches;
  const position = state => {
    if (state.mode !== 'popup' || state.panel.hidden) return;
    const rect = state.trigger.getBoundingClientRect();
    if (!state.trigger.getClientRects().length || rect.bottom < 0 || rect.top > innerHeight) { close(state); return; }
    const width = Math.min(980, innerWidth - 32);
    const top = Math.max(8, Math.min(rect.bottom + 10, innerHeight - 120));
    state.panel.style.left = `${Math.max(16, (innerWidth - width) / 2)}px`;
    state.panel.style.top = `${top}px`;
    state.panel.style.maxHeight = `${Math.max(100, innerHeight - top - 16)}px`;
  };
  const close = (state, restore = false) => {
    clearTimeout(state.timer);state.panel.hidden = true;state.trigger.setAttribute('aria-expanded', 'false');
    if (restore && state.trigger.isConnected) state.trigger.focus();
  };
  const selectGroup = (state, index) => {
    state.active = index;
    state.groups.forEach((group, i) => { group.open = i === index;state.tabs[i].setAttribute('aria-expanded', String(i === index)); });
  };
  const open = state => {
    clearTimeout(state.timer);
    states.forEach(other => { if (other !== state) close(other); });
    if (!accordion(state)) selectGroup(state, state.active);
    state.panel.hidden = false;state.trigger.setAttribute('aria-expanded', 'true');position(state);
  };
  function mount(nav, mode) {
    const label = Array.from(nav.querySelectorAll('a.primary-link[href]')).find(a => path(a.href) === hubPath);
    if (!label) return;
    const host = label.parentElement;
    if (states.some(s => s.host === host)) return;
    const oldArrow = Array.from(host.children).find(el => el.hasAttribute('data-dropdown-toggle'));
    const oldList = Array.from(host.children).find(el => el.matches('ul[data-is-dropdown]'));
    if (!oldArrow || !oldList) return; // A different theme structure keeps its original menu.
    const panel = source.cloneNode(true);
    panel.removeAttribute('data-rxcp-nav');panel.dataset.mode = mode;panel.hidden = true;
    const prefix = `rxcp-${mode}-${++serial}`;
    panel.id = `${prefix}-panel`;
    panel.querySelectorAll('[id]').forEach((el, i) => { el.id = `${prefix}-content-${i}`; });
    const trigger = document.createElement('button');trigger.type = 'button';trigger.className = 'rxcp-trigger';
    trigger.setAttribute('aria-label', 'Browse conditions by category');trigger.setAttribute('aria-expanded', 'false');trigger.setAttribute('aria-controls', panel.id);
    const state = { host, label, oldArrow, oldList, panel, trigger, mode, groups: Array.from(panel.querySelectorAll('[data-rxcp-group]')), tabs: [], active: 0, timer: null };
    if (!state.groups.length) return;
    const tabsHost = panel.querySelector('[data-rxcp-tabs]');
    tabsHost.setAttribute('aria-label', 'Condition categories');
    state.groups.forEach((group, index) => {
      const summary = group.querySelector('summary');const content = group.querySelector('.rxcp-group-content');
      const button = document.createElement('button');button.type = 'button';button.className = 'rxcp-tab';button.textContent = summary.textContent.trim();button.setAttribute('aria-controls', content.id);button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => selectGroup(state, index));
      button.addEventListener('keydown', event => {
        if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? state.tabs.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + state.tabs.length) % state.tabs.length;
        state.tabs[next].focus();selectGroup(state, next);
      });
      state.tabs.push(button);tabsHost.append(button);
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        state.active = index;
        if (accordion(state)) state.groups.forEach((other, i) => { if (i !== index) other.open = false; });
      });
    });
    tabsHost.hidden = false;panel.classList.add('rxcp-ready');
    selectGroup(state, accordion(state) ? -1 : 0);
    state.active = 0;
    trigger.addEventListener('click', event => { event.preventDefault();event.stopPropagation();state.panel.hidden ? open(state) : close(state); }, true);
    trigger.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault();close(state, true); }
      if (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey && !panel.hidden && mode === 'popup')) {
        event.preventDefault();open(state);focusables(panel)[0]?.focus();
      }
    });
    panel.addEventListener('click', event => { event.stopPropagation(); });
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault();event.stopPropagation();close(state, true);return; }
      if (event.key !== 'Tab' || mode !== 'popup') return;
      const elements = focusables(panel);
      if (event.shiftKey && document.activeElement === elements[0]) { event.preventDefault();close(state, true); }
      else if (!event.shiftKey && document.activeElement === elements[elements.length - 1]) {
        const pageElements = Array.from(document.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex="0"]')).filter(el => !panel.contains(el) && !el.closest('[hidden]') && el.getClientRects().length && !el.disabled);
        const next = pageElements[pageElements.indexOf(trigger) + 1];
        if (next) { event.preventDefault();close(state);next.focus(); }
        else close(state);
      }
    });
    if (mode === 'popup') {
      document.body.append(panel);
    } else host.append(panel);
    // Hide only the observed Conditions Treated controls after the replacement is ready.
    oldArrow.classList.add('rxcp-native-hidden');oldList.classList.add('rxcp-native-hidden');
    oldArrow.setAttribute('aria-expanded', 'false');
    label.insertAdjacentElement('afterend', trigger);host.classList.add('rxcp-host');states.push(state);
  }
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '').toLowerCase().trim();
  function initDirectory() {
    document.querySelectorAll('#rxo2-condition-directory').forEach(root => {
      if (root.dataset.ready) return;
      const input = root.querySelector('[data-rxcp-search]');const filter = root.querySelector('[data-rxcp-filter]');
      const cards = Array.from(root.querySelectorAll('[data-rxcp-card]'));const count = root.querySelector('[data-rxcp-count]');
      if (!input || !filter || !count) return;
      const synonyms = [
        [/\b(?:tbi|concussion)\b/g, 'traumatic brain injury'],[/\b(?:ibs?d|crohns|crohn)\b/g, 'crohn'],[/\buc\b/g, 'ulcerative colitis'],
        [/\bms\b/g, 'multiple sclerosis'],[/\bco poisoning\b/g, 'carbon monoxide'],[/\bssnhl\b/g, 'hearing loss'],[/\bcfs\b/g, 'fatigue'],[/\basd\b/g, 'autism']
      ];
      const update = () => {
        let query = normalize(input.value);synonyms.forEach(([pattern, replacement]) => { query = query.replace(pattern, replacement); });
        const terms = query.split(/\s+/).filter(Boolean);let visible = 0;
        cards.forEach(card => {
          const haystack = normalize(card.dataset.search || card.textContent);
          card.hidden = Boolean((filter.value && card.dataset.category !== filter.value) || !terms.every(term => haystack.includes(term)));
          if (!card.hidden) visible++;
        });
        count.textContent = `${visible} of ${cards.length} condition pages • A–Z`;
        root.querySelector('[data-rxcp-empty]').hidden = visible !== 0;
      };
      input.addEventListener('input', update);filter.addEventListener('change', update);
      root.querySelector('[data-rxcp-filters]').hidden = false;count.hidden = false;root.dataset.ready = 'true';update();
    });
  }
  function refresh() {
    const original = document.querySelector('[data-rxcp-nav]');
    if (!source && original) { source = original.cloneNode(true);original.remove(); }
    for (let i = states.length - 1; i >= 0; i--) {
      if (!states[i].host.isConnected) { close(states[i]);states[i].panel.remove();states.splice(i, 1); }
    }
    if (source) {
      const desktop = document.getElementById('header-navigation');const drawer = document.getElementById('drawer-navigation');
      if (desktop) mount(desktop, 'popup');if (drawer) mount(drawer, 'drawer');
    }
    initDirectory();
  }
  document.addEventListener('pointerdown', event => { states.forEach(state => { if (!state.host.contains(event.target) && !state.panel.contains(event.target)) close(state); }); });
  document.addEventListener('focusin', event => { states.forEach(state => { if (state.mode === 'popup' && !state.host.contains(event.target) && !state.panel.contains(event.target)) close(state); }); });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-header-drawer-toggle],a[href="#header-drawer-popout"]')) states.forEach(s => close(s));
  });
  window.addEventListener('resize', () => states.forEach(state => { if (!accordion(state)) selectGroup(state, state.active);position(state); }));
  window.addEventListener('scroll', () => states.forEach(position), { passive: true });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => states.forEach(s => close(s)));
  window.RXO2Conditions = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });else refresh();
})();
